import { useAuthState } from '../../services/auth';
import { useEffect, useState } from 'react';
import './dashboard.scss';
import axios from 'axios';
import { Alert, Card, Col, Row, Pagination, Table, Collapse, Form, Button, InputGroup } from 'react-bootstrap';

export const Dashboard = () => {
  const [ipCount, setIpCount] = useState(0);
  const { token } = useAuthState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dnsResponses, setDnsResponses] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<any>(1);
  const [pageSize, setPageSize] = useState<any>(1);
  const [activeItem, setActiveItem] = useState(null);

  const [domain, setDomain] = useState('');
  const [categories, setCategories] = useState<any[]>([]);
  const [answers, setAnswers] = useState<any[]>([]);
  const [isThreat, setIsThreat] = useState(false);
  const [isValidDomain, setIsValidDomain] = useState(true);
  console.log(token);
  useEffect(() => {
    if (token) {
      fetchDnsResponses();
    }
  }, [token, currentPage]);

  async function fetchDnsResponses() {
    const data = await axios.get('/op/dns/get_all_results?page=' + currentPage + '&pageSize=10&result=false');
    const dbsize = await axios.get('/op/dns/redis/dbsize');
    setIpCount(dbsize.data);
    setTotalCount(data.data.totalCount);
    setPageSize(data.data.pageSize);
    setDnsResponses(data.data.items);
    console.log('aqui', data.data.items);
  }

  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };
  const handleItemClick = (item: any) => {
    setActiveItem(activeItem === item ? null : item);
  };

  function formatDateTime(dateString: any) {
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      day: '2-digit',
      month: '2-digit',
    });
    const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    return formattedDateTime;
  }

  const getPageItems = () => {
    const pageItems = [];
    const maxPageItems = 5;
    const maxPageItemsDelta = Math.floor(maxPageItems / 2);
    const startPage = Math.max(currentPage - maxPageItemsDelta, 1);
    const endPage = Math.min(currentPage + maxPageItemsDelta, totalPages);

    if (startPage > 1) {
      pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
      const isCurrentPage = pageNumber === currentPage;
      pageItems.push(
        <Pagination.Item key={pageNumber} active={isCurrentPage} onClick={() => handlePageChange(pageNumber)}>
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    return pageItems;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDnsResponses();
    }, 1000 * 60 * 1);

    return () => clearInterval(interval);
  }, []);

  const handleChange = (event: any) => {
    setDomain(event.target.value);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const domainPattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
    const isValidDomain = domainPattern.test(domain);
    setIsValidDomain(isValidDomain);
    // Perform any necessary actions with the input value
    console.log('Input value:', domain);
    axios
      .post('/svc/dns', {
        domain,
      })
      .then((response) => {
        setAnswers(response.data.answers);
        setCategories(response.data.categories);
        setIsThreat(response.data.isThreatip);
        console.log(response.data);
      })
      .catch((error) => {
        console.log('Request error:', error);
      });
  };

  return (
    <>
      <Row>
        <Col>
          <Card bg="primary" text="white" style={{ width: '18rem' }}>
            <Card.Body>
              <Card.Title>Redis Ips</Card.Title>
              <Card.Text>
                <h1>{ipCount}</h1>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <hr></hr>
      <h3>Domain Tests</h3>
      <Form onSubmit={handleSubmit} className="mb-4">
        <Form.Group controlId="formInput">
          <InputGroup>
            <Form.Control type="text" placeholder="Enter a value" value={domain} onChange={handleChange} required={true} />
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </InputGroup>
        </Form.Group>
      </Form>
      {!isValidDomain && (
        <Alert key="danger" variant="danger">
          <Alert.Heading>Please, type a valid domain!</Alert.Heading>
        </Alert>
      )}
      {categories.length > 0 &&
        (isThreat === true ? (
          <Alert key="danger" variant="danger">
            <Alert.Heading>This ip is considerated a Threat</Alert.Heading>
          </Alert>
        ) : (
          <Alert key="success" variant="success">
            <Alert.Heading>This ip is not considerated a Threat</Alert.Heading>
          </Alert>
        ))}
      {categories.length > 0 &&
        categories.map((item: any) => (
          <Alert key={item.id} variant="dark">
            <p style={{ fontSize: 18 }}>
              <b>Domain: </b>
              {answers[0].name}
            </p>
            <p style={{ fontSize: 18 }}>
              <b>Category: </b>
              {item.name}
            </p>
            <p style={{ fontSize: 18 }}>
              <b>Description: </b>
              {item.description}
            </p>
          </Alert>
        ))}

      <hr></hr>
      <h3>Filter tests failed</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {dnsResponses.map((item: any) => (
            <>
              <tr style={item.result ? {} : { backgroundColor: '#f8d7da' }} key={item.uuid} onClick={() => handleItemClick(item)}>
                <td>{formatDateTime(item.responses[0].createdAt)}</td>
                <td>{item.result ? 'Success' : 'Fail'}</td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <Collapse in={activeItem === item}>
                    <Table bordered>
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Fqdn</th>
                          <th>Should be</th>
                          <th>Result</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.responses.map((response: any) => (
                          <tr style={response.result ? {} : { backgroundColor: '#f8d7da' }} key={response.dnsQueryId}>
                            <td>{response.description} </td>
                            <td> {response.fqdn} </td>
                            <td> {response.shouldBe ? 'Allowed' : 'Blocked'} </td>
                            <td> {response.result ? 'Success' : 'Fail'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Collapse>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
        {getPageItems()}
        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
    </>
  );
};
